import { fetchDataByMutate, postMutate } from 'utils/customMutation';
import { fetchData } from 'utils/customUseQuery';
import endPoints from 'utils/platformEndPoints/ossix';

export const ossixSupportCountries = () => {
  const { data, isLoading } = fetchData({
    url: endPoints.OssixCountries,
  });
  return {
    loadingCountry: isLoading,
    isLoading,
    countries: data ?? [],
  };
};

export const ossixProviders = () => {
  const {
    pureData,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.MNOList);

  return {
    ossixProvidersData: pureData,
    loadOssixProviders: isPending,
    isOssixProvidersError: isError,
    isOssixProvidersSuccess: isSuccess,
    ossixProvidersMessage: message,
    ossixProvidersError: error,
    mutate,
    clearData,
  };
};

export const requestVerifyAccount = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.VerifyGatewayAccount);

  return {
    loadVerifyAccount: isPending,
    verifyAccountData: data,
    isVerifyAccountError: isError,
    isVerifyAccountSuccess: isSuccess,
    verifyAccountMessage: message,
    verifyAccountError: error,
    mutate,
    clearData,
  };
};

export const fetchCurrenciesList = () => {
  const {
    pureData,
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.GetCurrenciesList);

  return {
    loadCurrenciesList: isPending,
    currenciesListData: pureData,
    isCurrenciesListError: isError,
    isCurrenciesListSuccess: isSuccess,
    currenciesListMessage: message,
    currenciesListError: error,
    mutate,
    clearData,
  };
};

export const requestTransferConfirmation = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = fetchDataByMutate(endPoints.GatewayTransferConfirmation);

  return {
    transferConfirmationData: data,
    loadTransferConfirmation: isPending,
    isTransferConfirmationError: isError,
    isTransferConfirmationSuccess: isSuccess,
    transferConfirmationMessage: message,
    transferConfirmationError: error,
    mutate,
    clearData,
  };
};

export const requestSendFundsToGateway = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = fetchDataByMutate(endPoints.SendFundsToGateway);

  return {
    sendFundsToGatewayData: data,
    loadSendFundsToGateway: isPending,
    isSendFundsToGatewayError: isError,
    isSendFundsToGatewaySuccess: isSuccess,
    sendFundsToGatewayMessage: message,
    sendFundsToGatewayError: error,
    mutate,
    clearData,
  };
};

export const requestBillsCategories = () => {
  const {
    pureData,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
  } = postMutate(endPoints.GetBillsCategoriesList);

  return {
    payBillsCategoryData: pureData,
    loadPayBillsCategory: isPending,
    isPayBillsCategoryError: isError,
    isPayBillsCategorySuccess: isSuccess,
    payBillsCategoryMessage: message,
    payBillsCategoryError: error,
    mutate,
  };
};

export const gatewayAddMoneyFees = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.GatewayAddMoneyFees);

  return {
    gatewayAddMoneyFeesData: data,
    loadGatewayAddMoneyFees: isPending,
    isGatewayAddMoneyFeesError: isError,
    isGatewayAddMoneyFeesSuccess: isSuccess,
    gatewayAddMoneyFeesMessage: message,
    gatewayAddMoneyFeesError: error,
    mutate,
    clearData,
  };
};

export const requestMoneyFromGateway = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.RequestMoneyFromGateway);

  return {
    moneyFromGatewayData: data,
    loadMoneyFromGateway: isPending,
    isMoneyFromGatewayError: isError,
    isMoneyFromGatewaySuccess: isSuccess,
    moneyFromGatewayMessage: message,
    moneyFromGatewayError: error,
    mutate,
    clearData,
  };
};

export const requestTransactionStatement = () => {
  const {
    pureData,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
  } = postMutate(endPoints.GetStatement, {
    responseType: 'blob',
  });

  return {
    transactionStatementData: pureData,
    loadTransactionStatement: isPending,
    isTransactionStatementError: isError,
    isTransactionStatementSuccess: isSuccess,
    transactionStatementMessage: message,
    transactionStatementError: error,
    mutate,
  };
};
